/**
 * Shared wrapper around validateFarmerOtp. Used by:
 *   - FarmerContextRoute middleware (categoryType = "PROFILE_GET")
 *   - Resource hooks that still need a per-resource OTP exchange (e.g.
 *     SOIL_CARD_STATUS_GET, FARMER_PASSBOOK_GET, SCHEME_APPLY)
 *
 * Replaces the four hand-rolled entitySearchRequest envelopes that lived
 * in SoilHealthOtpPage, FarmerPassbookOtpPage, CreateComplaint, and
 * SchemePageForm before this refactor.
 *
 * See .agent/rewamp/cta/middleware-refactor-plan.md §1.4.
 */
import { validateFarmerOtp } from "../../services/AgentService";
import { TENANT_ID } from "../../components/Utils";

/**
 * @param {object} args
 * @param {string} [args.dbtId]        13-digit DBT registration number.
 * @param {string} [args.mobileNumber] 10-digit registered mobile number.
 *                                     Pass exactly one of dbtId / mobileNumber —
 *                                     whichever the agent used to request the OTP.
 * @param {string} args.otp           6-digit OTP entered by the user.
 * @param {string} args.categoryType  Backend category — what resource the
 *                                    OTP is meant to unlock.
 * @param {object} [args.extra]       Extra entitySearchRequest fields
 *                                    (e.g. ticketId, additionalFileds.tokenId,
 *                                    customSearchCriteria). Shallow-merged.
 * @returns {Promise<import("axios").AxiosResponse>}
 */
export const verifyFarmerOtp = ({
  dbtId,
  mobileNumber,
  otp,
  categoryType,
  extra = {},
}) =>
  validateFarmerOtp({
    entitySearchRequest: {
      mobileNumber: mobileNumber ?? null,
      dbtId: dbtId ?? null,
      categoryType,
      tenantId: TENANT_ID,
      otp,
      ...extra,
    },
  });

export default verifyFarmerOtp;
